import React, {Component} from 'react';

class BlockSlideshow extends Component {
	
	constructor(props) {
		super(props)
		this.current = 0
		this.slider = null
		this.onchange = this.onchange.bind(this)
		this.next = this.next.bind(this)
	}
	
	
	componentDidMount() {
		document.addEventListener("visibilitychange", this.onchange);
		this.startSlider()
	}
	onchange(e) {
		this.startSlider()
	}
	startSlider() {
		if (document.hidden) {
			if (this.slider) {
				clearInterval(this.slider)
				this.slider = null
			}
		} else {
			if (!this.slider) {
				this.slider = setInterval(() => this.next(), 7500)
			}
		}
	}
	componentWillUnmount() {
		if (this.slider) clearInterval(this.slider)
		document.removeEventListener("visibilitychange", this.onchange);
	}
	
	
	next() {
		const {block} = this.props
		if(!block) return
		
		let slides = document.querySelectorAll(`#block-${block.uuid} .slideshow-slide`)
		if(!slides || slides.length===0) return
		
		if(this.current>=slides.length) this.current = 0
		
		let prev = this.current
		this.current += 1
		if (this.current>=slides.length) this.current = 0

		slides.forEach(slide => slide.classList.remove('active', 'prev'))
		slides[prev].classList.add('prev')
		slides[this.current].classList.add('active')
	}
	
	render() {
		const {block, classes, menu, childBlocks} = this.props

		return (
	<div className={classes} id={`block-${block.uuid}`}>
		{menu}
			<div className="slideshow-slideshow">
       				{childBlocks.map((slide, i) => 
       					<div className={'slideshow-slide' + (i===0?' active':'')} key={i}>
       						{slide}
       					</div>
       				)}
       				
  				<nav className="pager-controls">
    			<a
      				className="pager-control prev"
      				onClick={this.next}
    			>
      			<i className='fa fa-angle-left'/>
    			</a>
    			<a
      				className="pager-control next"
      				onClick={this.next}
    			>
      			<i className='fa fa-angle-right'/>
    			</a>
  				</nav>
  				
			</div>
    </div>
		)
	}
}
export default BlockSlideshow;

/*
import { ViewPager, Frame, Track, View } from 'react-view-pager'

class BlockSlideshow extends Component {
	render() {
		const {block, classes, children} = this.props

		const menu = children[0]
		const slides = children[1]

		return (
	<div className={classes} {...(block.p===null?{id:`section-${block.uuid}`}:{})}>
		{menu}
			<ViewPager tag="front-slideshow">
  				<Frame className="frame">
    			<Track
      				ref={c => this.track = c}
      				viewsToShow={1}
      				infinite
      				className="track"
    				>
       				{slides.map((slide, i) => 
       					<View className='view' key={i}>
       						{slide}
       					</View>
       				)}
    			</Track>
  				</Frame>
  				<nav className="pager-controls">
    			<a
      				className="pager-control prev"
      				onClick={() => this.track.prev()}
    			>
      			<i className='fa fa-angle-left'/>
    			</a>
    			<a
      				className="pager-control next"
      				onClick={() => this.track.next()}
    			>
      			<i className='fa fa-angle-right'/>
    			</a>
  				</nav>
			</ViewPager>
    </div>
		)
	}
}
export default BlockSlideshow;
*/
/*			<a className="product-view--open" onClick={() => dispatch(actions.openProducts())}>{strings.products}</a>*/



// WEBPACK FOOTER //
// ./src/fm/block/BlockSlideshow.js